module.exports = __webpack_public_path__ + "static/img/parnashotel.c98df2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/parnashotel.jpg
// module id = hxXm
// module chunks = 0